/**
 * FormSidePane & workflow-related constants.
 * Workflow status values match backend workflow.constants.js WORKFLOW_STATUSES.
 */
import {
  REQUISITION_WORKFLOW_LABELS,
  REQUISITION_WORKFLOW_PATHS,
} from "../../../utils/requisitionWorkflowRouting";

/** Workflow instance status constants (aligned with backend) */
export const WORKFLOW_STATUS = {
  DRAFT: 'DRAFT',
  FILING: 'FILING',
  VERIFICATION: 'VERIFICATION',
  APPROVAL: 'APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  RETURNED: 'RETURNED',
  CANCELED: 'CANCELED',
  PAYMENT: 'PAYMENT',
  PAID: 'PAID',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
};

/** Statuses that allow no further workflow actions (terminal). Used for defensive guards. */
export const TERMINAL_STATUSES = [
  WORKFLOW_STATUS.APPROVED,
  WORKFLOW_STATUS.REJECTED,
  WORKFLOW_STATUS.CANCELED,
];

export const DEFAULT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg';

export const ICON_CLASS = 'size-4 shrink-0';

export const WORKFLOW_ROUTES = Object.fromEntries(
  Object.entries(REQUISITION_WORKFLOW_PATHS).map(([workflowType, routeSegment]) => [
    workflowType,
    `/app/requisitions/${routeSegment}`,
  ])
);

export const WORKFLOW_TYPE_LABELS = {
  ...REQUISITION_WORKFLOW_LABELS,
};

export const STATUS_BADGE_CLASSES = {
  approved: 'bg-green-100 text-green-800',
  approval: 'bg-yellow-100 text-yellow-800',
  pending_approval: 'bg-yellow-100 text-yellow-800',
  verified: 'bg-blue-100 text-blue-800',
  verification: 'bg-blue-100 text-blue-800',
  pending_verification: 'bg-amber-100 text-amber-800',
  filing: 'bg-violet-100 text-violet-800',
  rejected: 'bg-red-100 text-red-800',
  draft: 'bg-slate-100 text-slate-800',
  default: 'bg-slate-100 text-slate-800',
};

/** Default control class for workflow form fields (Subject, Body, Folio, From, InitiatedAt, etc.). Text size and padding aligned with DynamicForm and To/UFS. */
export const DEFAULT_CONTROL_CLASS =
  'mt-1 w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-slate-700 shadow-sm focus:border-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-dark/30';

/** Disabled/read-only control class for workflow form fields */
export const DISABLED_CLASS =
  'mt-1 w-full rounded-lg border border-gray-300/50 bg-gray-300/50 px-3 py-2 text-sm text-slate-600 shadow-sm cursor-not-allowed focus:outline-none focus:ring-0';
